import { useBlinkContextWithValidation, } from '@thoughtspot/blink-context';
import { useEffect } from 'react';
const SPARKFLOW_METRICS_SERVICE_CONTRACT = [
    { propName: 'collectEvent', propType: 'function' },
];
const SPARKFLOW_NAV_SERVICE_CONTRACT = [
    { propName: 'goToHome', propType: 'function' },
    { propName: 'readClientQueryParamsFromPath', propType: 'function' },
    { propName: 'goToAskSageChat', propType: 'function' },
    { propName: 'goToDevelopTab', propType: 'function' },
    { propName: 'goToSparkflowPinboard', propType: 'function' },
    { propName: 'goToPinboard', propType: 'function' },
    { propName: 'goToUrl', propType: 'function' },
    { propName: 'goToSpotbuildIntegration', propType: 'function' },
    { propName: 'goToAgentSelection', propType: 'function' },
    { propName: 'goToSparkflowOnboarding', propType: 'function' },
    { propName: 'goToSpotbuildIntegration', propType: 'function' },
    { propName: 'goToAgentSelection', propType: 'function' },
];
const SPARKFLOW_SESSION_SERVICE_CONTRACT = [
    { propName: 'userType', propType: 'function' },
    { propName: 'getUserEmail', propType: 'function' },
    { propName: 'getClusterId', propType: 'function' },
    { propName: 'getUserDisplayName', propType: 'function' },
    { propName: 'getSessionInfo', propType: 'function' },
    { propName: 'setSessionInfo', propType: 'function' },
    { propName: 'getUserName', propType: 'function' },
    { propName: 'getCurrentOrgId', propType: 'function' },
    { propName: 'setEdgeOnboardingCompleted', propType: 'function' },
    { propName: 'setOnboardingLocationSelected', propType: 'function' },
    { propName: 'getProductName', propType: 'function' },
    { propName: 'isOnboardingMTServicesEnabled', propType: 'function' },
    {
        propName: 'isSparkflowUsecaseBasedOnboardingEnabled',
        propType: 'function',
    },
    { propName: 'isSparkflowV2Enabled', propType: 'function' },
];
const SPARKFLOW_CUSTOM_STYLING_SERVICE_CONTRACT = [
    { propName: 'getConfig', propType: 'function' },
];
export const useBlinkContextForSparkflow = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        metricsServiceContract: SPARKFLOW_METRICS_SERVICE_CONTRACT,
        sessionServiceContract: SPARKFLOW_SESSION_SERVICE_CONTRACT,
        navServiceContract: SPARKFLOW_NAV_SERVICE_CONTRACT,
        customStylingServiceContract: SPARKFLOW_CUSTOM_STYLING_SERVICE_CONTRACT,
    });
    return blinkContext;
};
export const useValidateBlinkContextForSparkflow = () => {
    const [validate, blinkContext] = useBlinkContextWithValidation({
        metricsServiceContract: SPARKFLOW_METRICS_SERVICE_CONTRACT,
        sessionServiceContract: SPARKFLOW_SESSION_SERVICE_CONTRACT,
        navServiceContract: SPARKFLOW_NAV_SERVICE_CONTRACT,
    });
    useEffect(() => {
        validate('SPARKFLOW');
    }, [validate]);
    return blinkContext;
};
//# sourceMappingURL=sparkflow-blink-context.js.map